module.exports = __webpack_public_path__ + "img/climbers-mobile.d1a355db.png";